export default function useRange(size: number) {
  return Array.from(Array(size).keys())
}
